import { render } from "./UploadImage.vue?vue&type=template&id=756a6af4&scoped=true"
import script from "./UploadImage.vue?vue&type=script&lang=js"
export * from "./UploadImage.vue?vue&type=script&lang=js"

import "./UploadImage.vue?vue&type=style&index=0&id=756a6af4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-756a6af4"]])

export default __exports__